import { render, staticRenderFns } from "./OutgoingProducts.vue?vue&type=template&id=44364ce6&"
import script from "./OutgoingProducts.vue?vue&type=script&lang=js&"
export * from "./OutgoingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports